import $ from "jquery";

const chapterVideo = () => {
  const init = () => {

    Content();
  };

  const Content = () => {
    let player = {};
    let sliderDragging = false;
    const videoTitle = $(".js-VideoTitle");
    const playPauseButton = $(".js-VideoButton--Play");
    // const durationTime = $(".js-VideoButton--DurationTime");
    // const currentTime = $(".js-VideoButton--CurrentTime");
    const progressBarContainer = $(".mi-Chapter__Container_Row__Col_Footer__Button__ProgressBar_Container");
    const progressBar = $(".js-VideoButton--ProgressBar");
    const slider = $(".js-VideoButton--Slider");
    // const speedButton = $(".js-VideoButton--Speed");


    // chapter button prev, next, cross close
    const nextButtonChapter = $(".js-ChapterVideoButton__Next");
    const prevButtonChapter = $(".js-ChapterVideoButton__Prev");
    const closeButtonChapter = $(".js-ChapterVideoButton__Close");
    const volumeButtonChapter = $(".js-ChapterVideoButton__Volume");

    // popup chapter button back and cross close
    const CloseButtonPopupChapter = $(".js-PopupCloseChapter_Btn");
    CloseButtonPopupChapter.addClass("js-PopupChapterVideoButton__Close");

    const BackButtonPopupChapter = $(".js-PopupButtonChapter__Back");
    BackButtonPopupChapter.addClass("js-PopupChapterVideoButton__Back");

    // Buttons only do play and toggle play/pause button
    const buttonsPlay = [
      ".js-PopupChapterVideoButton__Back",
      ".js-PopupChapterVideoButton__Close",
    ];

    // Buttons only do pause and toggle play/pause button
    const buttonsPause = [
      nextButtonChapter,
      prevButtonChapter,
      closeButtonChapter,
    ];

    if ($("#Chapter__Video") === 0) return;


    function initializePlayer() {
      // eslint-disable-next-line
      $(".js-ChapterVideo__Content").each(function () {
        // eslint-disable-next-line no-undef
        player[$(this).attr('id')] = new YT.Player(`${$(this).attr('id')}`, {
          events: {
            'onReady': onPlayerReady($(this).attr('id')),
            'onStateChange': onPlayerStateChange($(this).attr('id'))
          }
        });
      })
    }
    window.onYouTubeIframeAPIReady = initializePlayer;

    // play/pause video
    const playPauseAction = (id) => {
      // eslint-disable-next-line
      if (player[id].getPlayerState() == YT.PlayerState.PLAYING) {
        player[id].pauseVideo();
      } else {
        player[id].playVideo();
      }
    };

    // toggle play/pause video
    const togglePlayPauseButton = () => {
      if (playPauseButton.hasClass("js-VideoButton--Play")) {
        playPauseButton.removeClass("js-VideoButton--Play");
        playPauseButton.addClass("js-VideoButton--Pause");
      } else {
        playPauseButton.removeClass("js-VideoButton--Pause");
        playPauseButton.addClass("js-VideoButton--Play");
      }
    };

    const toggleMuteUnMuteButton = (id) => {
      if ($(`#Volume-${id}`).hasClass("js-VideoButton--Volume")) {
        $(`#Volume-${id}`).removeClass("js-VideoButton--Volume");
        $(`#Volume-${id}`).addClass("js-VideoButton--VolumeMute");
      } else {
        $(`#Volume-${id}`).removeClass("js-VideoButton--VolumeMute");
        $(`#Volume-${id}`).addClass("js-VideoButton--Volume");
      }
    };

    // Define the onPlayerReady function
    const onPlayerReady = (id) => () => {

      // get duration of video
      let dur = player[id].getDuration();
      let minutes = Math.floor(dur / 60);
      let seconds = Math.floor(dur % 60);
      // durationTime.text(' / ' + minutes + ":" + (seconds < 10 ? "0" : "") + seconds);
      $(`#DurationTime-${id}`).text(' / ' + minutes + ":" + (seconds < 10 ? "0" : "") + seconds);

      // get video title
      let title = $('#ChapterVideo__Content').attr('title');
      videoTitle.text(title)

      // play/pause button
      let playButtonClickeed = false;
      playPauseButton.on("click", function () {
        playButtonClickeed = true;
        playPauseAction($(this).data('id_frame'));
        togglePlayPauseButton($(this).data('id_frame'));
      });

      // pause button
      $.each(buttonsPause, function (index, button) {
        button.on("click", function () {
          player[id].pauseVideo();
          playPauseButton.removeClass("js-VideoButton--Pause");
          playPauseButton.addClass("js-VideoButton--Play");
        });
      });

      // play button
      $.each(buttonsPlay, function (index, button) {
        $(document).on("click", button, function () {
          if (playButtonClickeed) {
            player[id].playVideo();
            playPauseButton.removeClass("js-VideoButton--Play");
            playPauseButton.addClass("js-VideoButton--Pause");
          } else {
            return;
          }
        });
      });

      nextButtonChapter.on("click", function () {
        BackButtonPopupChapter.removeClass("js-PopupChapterVideoButton__Back");
        CloseButtonPopupChapter.removeClass("js-PopupChapterVideoButton__Close");
      });

      // MUTE AND UNMUTE VIDEO
      volumeButtonChapter.on("click", function () {
        if (player[id].isMuted()) {
          player[id].unMute();
        } else {
          player[id].mute();
        }
        toggleMuteUnMuteButton(id);
      });

      // handle speed button
      $(`#Speed-${id}`).on("click", function () {
        if ($(`#Speed-${id}`).html() === '1x') {
          $(`#Speed-${id}`).html('1.5x')
          player[id].setPlaybackRate(1.5);
        }
        else if ($(`#Speed-${id}`).html() === '1.5x') {
          $(`#Speed-${id}`).html('2x')
          player[id].setPlaybackRate(2);
        }
        else if ($(`#Speed-${id}`).html() === '2x') {
          $(`#Speed-${id}`).html('2.5x')
          player[id].setPlaybackRate(2.5);
        }
        else if ($(`#Speed-${id}`).html() === '2.5x') {
          $(`#Speed-${id}`).html('3x')
          player[id].setPlaybackRate(3);
        }
        else {
          $(`#Speed-${id}`).html('1x')
          player[id].setPlaybackRate(1);
        }
      })

    }

    // Define the onPlayerStateChange function
    const onPlayerStateChange = (id) => () => {
      if (player[id].getPlayerState() == 1) {
        playPauseButton.removeClass("js-VideoButton--Play");
        playPauseButton.addClass("js-VideoButton--Pause");
      } else {
        playPauseButton.removeClass("js-VideoButton--Pause");
        playPauseButton.addClass("js-VideoButton--Play");
      }
      // Get the current time every second
      setInterval(function () {
        let curr = player[id].getCurrentTime();
        let minutes = Math.floor(curr / 60);
        let seconds = Math.floor(curr % 60);
        // currentTime.text(minutes + ":" + (seconds < 10 ? "0" : "") + seconds);
        $(`#CurrentTime-${id}`).text(minutes + ":" + (seconds < 10 ? "0" : "") + seconds);

        let percentage = (curr / player[id].getDuration()) * 100;

        // progressBar.css("width", percentage + "%");
        // slider.css("left", percentage + "%");
        $(`#Progress-${id}`).css("width", percentage + "%");
        $(`#Slider-${id}`).css("left", percentage + "%");
      }, 1000);
      // }

      // update the progressbar when click to slide
      $(`#ContainerProgress-${id}`).on("click", function (e) {
        let containerWidth = $(this).width();
        let clickX = e.pageX - $(this).offset().left;
        let duration = player[id].getDuration();
        let targetTime = (clickX / containerWidth) * duration;
        player[id].seekTo(targetTime)
      });

      // handling drag the slider
      slider.on("mousedown", function () {
        sliderDragging = true;
      });

      $(document).on("mouseup", function () {
        if (sliderDragging) {
          sliderDragging = false;
        }
      });

      progressBarContainer.on("mousemove", function (e) {
        if (sliderDragging) {
          let containerWidth = $(this).width();
          let clickX = e.pageX - $(this).offset().left;
          let progress = (clickX / containerWidth) * 100;
          if (progress >= 0 && progress <= 100) {
            slider.css('left', progress + '%');
            progressBar.css('width', progress + '%');
            player[id].seekTo((progress / 100) * player[id].getDuration())
          }
        }
      });
    }


    // Inject YouTube API script
    let tag = document.createElement("script");
    tag.src = "https://www.youtube.com/player_api";
    let firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  };

  init();
};
chapterVideo();
